// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1-XPr","containerItemsCenter":"Skeleton_containerItemsCenter__3dDZA"};